import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const oneLogin = defineConnector({
  identifier: "oneLogin",
  name: "OneLogin",
  tagLine: "Identity and access management",
  logo,
  protocol: "http",
  tags: ["identity", "it"],
  defaultUrlPattern: () => "https://.*\\.onelogin\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create API credentials in OneLogin",
      items: [
        {
          kind: "markdown",
          content: `1. In OneLogin, go to **Developers › API Credentials**
2. Click "New Credential"
3. Give it a name and select the appropriate permissions
4. Copy the Client ID and Client Secret`,
        },
      ],
    },
    {
      title: "Enter your OneLogin details",
      items: [
        {
          kind: "hostname",
          label: "Subdomain",
          required: true,
          placeholder: "acme",
          target: { kind: "configuration", field: "domain" },
          helperText:
            "Your OneLogin domain (e.g., “acme” for acme.onelogin.com).",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ domain }) => `https://${domain}/auth/oauth2/v2/token`,
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_basic",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/2/users?limit=1`,
  },
  publicEnvVars: ({ domain }) => ({
    ONE_LOGIN_URL: domain ? `https://${domain}.onelogin.com` : "",
  }),
});
